<template>
    <div>
        <b-btn variant="info" size="sm" @click.prevent="showInfoWindow" title="Ver planes y precios de Vecindapp">Planes y precios</b-btn>
        <app-modal
            title="Conoce los planes y precios de Vecindapp"
            id="vecindapp-info-window"
            size="xl"
            centered
            hide-footer
        >
            <b-row align-v="center">
                <b-col cols="12" md="12">
                    <img src="img/tipos_licencia.png" alt="Imagen de ejemplo" class="img-fluid mb-3" />
                </b-col>
            </b-row>
            <b-row class="button-container g-0"> <!-- g-0 elimina el gutters entre columnas -->
                <b-col cols="4" class="pe-1"> <!-- pe-1 agrega un pequeño padding a la derecha -->
                    <b-button 
                        @click="showCalculatePriceWindow" 
                        variant="secondary" 
                        class="w-100 button-design"
                    >
                        Calcular precio
                    </b-button>
                </b-col>
                <b-col cols="4" class="ps-1"> <!-- ps-1 agrega un pequeño padding a la izquierda -->
                    <b-button 
                        @click="onContactAdvisor" 
                        variant="primary" 
                        class="w-100 button-design"
                    >
                        Contactar asesor
                    </b-button>
                </b-col>
                <b-col cols="4" class="ps-1"> <!-- ps-1 agrega un pequeño padding a la izquierda -->
                    <b-button 
                        @click="onSeeMoreDetails" 
                        variant="primary" 
                        class="w-100 button-design"
                    >
                        Ver más detalles
                    </b-button>
                </b-col>
            </b-row>
        </app-modal>
        <app-modal
            title="Calcula el precio de la licencia que necesitas"
            id="calculate-license-price-window"
            @ok="calculatePrice()"
            ok-title="Calcular"
            size="lg"
            :ok-disabled="busy"
            ok-icon="fa-calculator"
        >
        <!-- Contenedor para centrar el campo -->
        <div class="d-flex justify-content-center align-items-center">
            <b-row align-v="center">
                <b-col cols="12">
                    <app-form-input
                        label="Ingresa el número de unidades residenciales"
                        v-model="unitsNumber"
                        type="number"
                        required
                        @input="$v.unitsNumber.$touch()"
                        :error="$v.unitsNumber.$error"
                    ></app-form-input>
                </b-col>
            </b-row>
        </div>
            <!-- Resultados de las licencias -->
            <div v-if="licensePrices && licensePrices.length" class="mt-4">
                <div class="result-header p-3 bg-light rounded">
                    <h5 class="mb-0">Para {{ unitsNumber }} unidades, tenemos las siguientes licencias disponibles:</h5>
                </div>

                <div class="licenses-container mt-3">
                    <b-row>
                        <b-col cols="12" md="4" v-for="license in licensePrices" :key="license.name">
                            <div class="license-card p-3 mb-3">
                                <h4 class="license-name">{{ license.name }}</h4>
                                <div class="price-tag mt-2">
                                    <span class="currency">$</span>
                                    <span class="amount">{{ formatPrice(license.price) }}</span>
                                </div>
                                <div class="license-range mt-2">
                                    <small class="text-muted">
                                        Rango: {{ license.from }} - {{ license.to }} unidades
                                    </small>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div v-if="licensePrices.length === 0 && hasSearched">
                <div class="result-header p-3 bg-light rounded">
                    <h5 class="mb-0">Por ahora no tenemos una licencia que se ajuste a tus necesidades.</h5>
                </div>
            </div>
        </app-modal>
    </div>
</template>
<script>
import { required, numeric, minValue } from 'vuelidate/lib/validators';
    export default {
        data: () => ({
            busy: false,
            unitsNumber: null,
            licensePrices: [],
            hasSearched: false,
        }),
        validations: {
            unitsNumber: {
                required,
                numeric,
                minValue: minValue(1),
            },
        },
        methods: {
            formatPrice(price) {
                return Number(price).toLocaleString('es-CO');
            },
            onSeeMoreDetails() {
                window.open('https://vecindapp.com.co/', '_blank');
            },
            showInfoWindow() {
                this.$bvModal.show('vecindapp-info-window');
            },
            onContactAdvisor() {
                const whatsappNumber = this.getSystemParam('SELLER_CONTACT');              
                const message = encodeURIComponent('¡Ya tengo Vecindapp y quiero saber más!');
                const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
                window.open(whatsappUrl, '_blank');
            },
            showCalculatePriceWindow() {
                this.$bvModal.show('calculate-license-price-window');
            },
            async calculatePrice() {
                if (this.$v.$invalid) {
                    this.$v.$touch();
                    return;
                }
                this.busy = true;
                try{
                    const { data } =  await this.$repo.get('sales/license-price', {
                        units: this.unitsNumber
                    });
                    this.licensePrices = data.data;
                    this.hasSearched = true;
                    }catch(error){
                        console.error(error);
                    }
                    this.busy = false;
                //this.$bvModal.hide('calculate-license-price-window');
            },
        },
    };
</script>
<style scoped>
.result-header {
  border-left: 4px solid #17a2b8;
}

.license-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;
  height: 100%;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.license-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.license-name {
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.price-tag {
  color: #17a2b8;
  font-weight: bold;
}

.currency {
  font-size: 1.2rem;
  vertical-align: top;
}

.amount {
  font-size: 1.5rem;
}

.license-range {
  border-top: 1px solid #eee;
  padding-top: 0.5rem;
}

.button-container {
  margin: 0;
  width: 100%;
}

.button-design {
  padding: 0.75rem 1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Hacer los botones responsive en móviles */
@media (max-width: 768px) {
  .button-container .col-6 {
      padding: 0.5rem;
  }
}
</style>
